import React from 'react';
import { compose, mapProps } from 'recompose';
import { graphql } from 'react-apollo';
import { withTranslation } from 'react-i18next';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import Routes from 'utils/routes/appRoutes';
import UserBadge from 'components/threepp/UserBadge/UserBadge';
import { getCurrentUser as getCurrentUserSelector } from 'selectors/user/selector';
import { getCurrentUser } from 'graphql/operations';
import './NavHeader.scss';
import { IconButton } from '@material-ui/core';
import { Menu as MenuIcon } from '@material-ui/icons';

export class NavHeader extends React.Component {
  state = {
    open: false
  };

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  userLogout = () => {
    const { history } = this.props;
    history.push(Routes.logout.path);
  };

  render() {
    const { t, currentUser, navDrawerOnChange, toggleUserProfileModal, displayHelpModal } = this.props;
    const { open } = this.state;
    return (
      <>
        <div className="nav-header">
          <AppBar position="static" className="app-header">
            <Toolbar variant="dense" disableGutters={!open}>
              <div className="brand">
                <div className="guided-tour-hamburger-menu-wrapper">
                  <div className="guided-tour-hamburger-menu" />
                  <IconButton className="nav-icon-button" onClick={navDrawerOnChange}>
                    <MenuIcon />
                  </IconButton>
                </div>
                <div className="guided-tour-logo-wrapper">
                  <div className="guided-tour-logo" />

                  {/* TODO: Fix this... */}
                  {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
                  <div className="threepp-logo" />
                  {/* <span className='threepp-name'>{t('productName')}</span> */}
                </div>
              </div>

              {/* Hook divs to show guided tour around user name and dropdown menu */}
              <div className="guided-tour-my-profile-wrapper">
                <div className="guided-tour-my-profile" />
                <UserBadge user={currentUser} noName />

                <UncontrolledDropdown className="nav-dropdown">
                  <DropdownToggle caret color="" data-testid="navUser-dropdown" />
                  <DropdownMenu>
                    <DropdownItem data-testid="navUser-option-userProfile" onClick={toggleUserProfileModal}>
                      {t('userProfile.header')}
                    </DropdownItem>
                    <DropdownItem data-testid="navUser-option-globalHelp" onClick={displayHelpModal}>
                      {t('common.globalHelp')}
                    </DropdownItem>
                    <DropdownItem data-testid="navUser-option-userLogout" onClick={this.userLogout}>
                      {t('common.logout')}
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </Toolbar>
          </AppBar>
        </div>
      </>
    );
  }
}

export const NavHeaderHOC = compose(
  withTranslation(),
  withRouter,
  graphql(getCurrentUser, { name: 'getCurrentUser' }),
  mapProps(props => ({
    t: props.t,
    history: props.history,
    location: props.location,
    currentUser: getCurrentUserSelector(props),
    navDrawerOnChange: props.navDrawerOnChange,
    toggleUserProfileModal: props.toggleUserProfileModal,
    displayHelpModal: props.displayHelpModal
  }))
);

export default NavHeaderHOC(NavHeader);
